import axios from 'axios'
import { i18n } from '../../../../plugins/i18n'

export const companiesAnalysisSettingsIgnores = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readIgnoresSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
    },
    createIgnoreSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    deleteIgnoreSuccess(state, ignore_id) {
      state.data = state.data.filter(function(value){
        return value.id != ignore_id
      })
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readIgnores({ commit }, company_uuid) {
      commit('prepareConnect')
      axios
        .get('/api/companies/' + company_uuid + '/analysis/settings/ignores' + '.json')
        .then(res => {
          commit('readIgnoresSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createIgnore({ commit }, { company_uuid, payload }) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + company_uuid + '/analysis/settings/ignores' + '.json', payload)
        .then(() => {
          commit('createIgnoreSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('pages.CompaniesReviews.SettingKeywordModal.message.ignored') }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    deleteIgnore({ commit }, { company_uuid, ignore_id }) {
      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + company_uuid + '/analysis/settings/ignores/' + ignore_id + '.json')
        .then(() => {
          commit('deleteIgnoreSuccess', ignore_id)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
